import React, { useEffect, useState } from 'react';

let initialized = false;
export const useEmojiInitialization = () => {
    const [isInitialized, setInitialized] = useState(false);

    useEffect(() => {
        const initializeEmojiMart = async () => {
            if (initialized) return; // make sure init only once
            try {
                const emojiData = await import('@emoji-mart/data');
                const { init } = await import('emoji-mart');
                // Create a local copy
                init({ data: { ...emojiData } });
                setInitialized(true);
                initialized = true;
            } catch (error) {
                console.error('Failed to initialize emoji-mart:', error);
            }
        };

        initializeEmojiMart();
    }, []);

    return isInitialized;
};
